'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./Spinner.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Spinner(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height,
      _ref$primary = _ref.primary,
      primary = _ref$primary === undefined ? false : _ref$primary;

  return _react2.default.createElement(
    'svg',
    {
      focusable: 'false',
      'aria-hidden': true,
      className: (0, _classnames2.default)('icon-svg-spinner', className, { primary: primary }),
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement(
      'g',
      { transform: 'translate(8, 8)' },
      _react2.default.createElement('circle', {
        cx: '0',
        cy: '0',
        r: '7',
        fill: 'rgba(0,0,0,0)',
        stroke: color,
        strokeWidth: '2',
        strokeDasharray: '33' })
    )
  );
}

Spinner.propTypes = {
  color: _react.PropTypes.string,
  className: _react.PropTypes.string,
  width: _react.PropTypes.number,
  height: _react.PropTypes.number,
  primary: _react.PropTypes.bool
};

Spinner.displayName = 'Spinner';

exports.default = Spinner;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Spinner/Spinner.js
// module id = 337
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16